<script setup lang="ts">
import type { LucideIcon } from 'lucide-vue-next'

const props = withDefaults(defineProps<Props>(), {
	label: '',
})

interface Props {
	label?: string
	icon: LucideIcon
}
</script>

<template>
	<Button
		class="tracking-tight flex mx-auto md:mx-0 w-fit items-center group relative gap-3 px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105 overflow-hidden"
	>
		<!-- Button background effects -->
		<div class="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
		<div class="absolute -top-2 -right-2 w-8 h-8 bg-white/20 rounded-full blur-sm opacity-60" />

		<!-- Button content -->
		<props.icon class="w-5 h-5 relative z-10 group-hover:rotate-12 transition-transform duration-300" />
		<span class="relative z-10">{{ props.label }}</span>

		<!-- Shine effect -->
		<div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />
	</Button>
</template>
